import {useState, useEffect} from 'react'
import { contractService } from '../../../api/contractService'
import { DirectionService } from '../../../api/directionService'
import { Controller, useForm } from 'react-hook-form'
import Select from 'react-select'
import classes from './newContracts.module.scss'
import classNames from 'classnames';
import {toast} from 'react-toastify'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const NewContracts = () => {

    const [hospitals, setHospitals] = useState([])
    const [newData,setNewData] = useState()
    const { control, handleSubmit, register,formState: {errors},watch } = useForm()
    const role = useSelector(state=>state.login.userInfo.permissions.contracts_manage)
    const navigate = useNavigate()

    useEffect(() => {
        if (!role){
            navigate('/Home')
            toast.error('В доступі відмовлено!')
        }
        DirectionService.getOptions()
          .then(res => {
            if (res?.data?.hospitals) {
                let arr = []
                res.data.hospitals.map(el=>{
                    if(el.registrationType == "COMPLETED"){
                        arr.push(el)
                    }
                })
              setHospitals(arr)
            }
          })
          .catch(console.error)
      }, [])
    
      // map your hospitals into the format react-select wants:
      const selectOptions = hospitals.map(el => ({
        value: el.id,
        label: el.name
    }))
    
    const onSubmit = (data) => {
        setNewData({
            "number": data.number,             
            "name": data.name,           
            "hospitalId": data.hospitalId,     
            "startDate": (new Date(data.startDate)).toISOString(),          
            "endDate": (new Date(data.endDate)).toISOString(),  
            "signedAt": (new Date(data.signedAt)).toISOString(),          
            "status": "active",
            "agreements": {
                "ІГХ": data.IGH, 
                "Експрес": data.Express,
                "Гістологія": {
                    "1": data.lev1,
                    "2": data.lev2,
                    "3": data.lev3,
                    "4": data.lev4,
                    "5": data.lev5
                }, 
                "CISH": data.CISH}  
        })
    }

    const hospitalId = watch('hospitalId')

    useEffect(()=>{
        if(newData !== undefined){
            sendContract(newData)
        }
    },[newData])

    const sendContract = async(data) =>{
        await contractService.createContract(data, hospitalId).then(res => {
            if (res) {
                console.log('done')
                toast.info('Контракт сформовано')
            }
        })
        navigate('/Contracts')
    }

    const formData = {
        "title": 'Новий контракт',
        "fields":[
            {
                "legend": 'Номер договору',
                "id":1,
                "type": 'text',
                "required": true,
                "name": 'number',
                "options": false,
            },{
                "legend": 'Назва договору',
                "id":2,
                "type": 'text',
                "required": true,
                "name": 'name',
                "options": false,
            },{
                "legend": 'Дата початку договору',
                "id":3,
                "type": 'date',
                "required": true,
                "name": 'startDate',
                "options": false,
            },{
                "legend": 'Дата завершення договору',
                "id":4,
                "type": 'date',
                "required": true,
                "name": 'endDate',
                "options": false,
            },{
                "legend": 'Дата підписання договору',
                "id":41,
                "type": 'date',
                "required": true,
                "name": 'signedAt',
                "options": false,
            },{
                "legend": 'Дослідження',
                "id":5,
                "type": 'number',
                "required": true,
                "name": 'IGH',
                "options": true,
                "props":[
                    {
                        "legend": 'ІГХ',
                        "id":5,
                        "type": 'number',
                        "required": true,
                        "name": 'IGH',
                        "levels": [],
                        "options": true,
                    },{
                        "legend": 'Гістологія',
                        "id":6,
                        "type": 'number',
                        "required": true,
                        "name": 'Gistology',
                        "levels": [
                            "lev1",
                            "lev2",
                            "lev3",
                            "lev4",
                            "lev5"
                        ],
                        "options": true,
                    },{
                        "legend": 'Експрес',
                        "id":7,
                        "type": 'number',
                        "required": true,
                        "name": 'Express',
                        "levels": [],
                        "options": true,
                    },{
                        "legend": 'CISH',
                        "id":8,
                        "type": 'number',
                        "required": true,
                        "name": 'CISH',
                        "levels": [],
                        "options": true,
                    },
                ]
            }
        ]
    }

  return (
    <div>
        <h2>Створити договір</h2>
        <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
            {formData.fields.map((props, index)=>(
                (!props.options && <div className={classes.form__box__register} key={index}>
                    <div><label>{props.legend}</label></div>
                    <div>
                        <input
                        className={classNames(classes.form__input, {[classes.errorInput]: errors[props.name]})}
                        type={props.type}
                        placeholder='Введіть свої значення...'
                        name={props.name}
                        {...register(props.name, {required: props.required})}
                        />
                    </div>
                </div> || props.options && !props.levels && 
                    <div className={classes.form__box__register} key={index}>
                        <div><label>{props.legend}</label></div>
                        <div className={classes.form__block}>
                            {props.props.map((el,i)=>(
                                el.levels.length === 0 ? <div>
                                    <div><label>{el.legend}</label></div>
                                    <input
                                    className={classNames(classes.form__input__agr, {[classes.errorInput]: errors[props.name]})}
                                    type={el.type}
                                    name={el.name}
                                    placeholder='Введіть свої значення...'
                                    defaultValue={0}
                                    {...register(el.name)}
                                    />
                                </div> : <div>
                                    <div><label>{el.legend}</label></div>
                                    {el.levels.map((lev,index)=>
                                    (<div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                                        <div><label>Категорія {index + 1}</label></div>
                                        <input
                                        style={{marginBottom: '5px'}}
                                        className={classNames(classes.form__input__agr, {[classes.errorInput]: errors[props.name]})}
                                        type={el.type}
                                        name={lev}
                                        placeholder='Введіть свої значення...'
                                        defaultValue={0}
                                        {...register(lev)}
                                        />
                                    </div>)
                                    )}
                                </div>
                            ))}
                        </div>
                </div>
                )
            ))}
            <Controller
                control={control}
                name="hospitalId"
                render={({ field: { onChange, value } }) => (
                    <Select
                    className={classes.select}
                    options={selectOptions}
                    value={ selectOptions.find(opt => opt.value === value) || null }
                    onChange={opt => onChange(opt?.value)}
                    placeholder="Оберіть лікарню"
                    isClearable
                    />
                )}
            />
            <button className={classes.form__button} type='submit'>Створити</button>
        </form>    
    </div>
    
  )
}

export default NewContracts
